(function () {
  'use strict';
  // Effetto MACCHINA DA SCRIVERE sui titoli marcati .js-tw: si scrivono lettera
  // per lettera quando entrano a schermo (una volta sola). I testi LUNGHI (> 80
  // caratteri) restano standard, per non stancare l'occhio. Rispetta reduce-motion.
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('.js-tw');
  if (!els.length) return;
  var entranceReady = false;
  var pendingSteps = [];
  function resume() {
    entranceReady = true;
    pendingSteps.splice(0).forEach(function (step) { step(); });
  }
  window.addEventListener('pagehide', function () { entranceReady = false; });

  function type(el) {
    if (!entranceReady || el.dataset.tw) return;
    el.dataset.tw = '1';
    el.classList.remove('js-tw-armed');
    var text = el.textContent;
    if (reduce || text.length > 80) return; // titoli lunghi / reduce-motion: mostra e basta
    el.textContent = '';
    el.classList.add('js-tw-caret');
    var i = 0;
    (function step() {
      if (!entranceReady) { pendingSteps.push(step); return; }
      if (i <= text.length) { el.textContent = text.slice(0, i); i++; setTimeout(step, 34); }
      else { el.classList.remove('js-tw-caret'); }
    })();
  }

  Array.prototype.forEach.call(els, function (el) { el.classList.add('js-tw-armed'); });

  if (!('IntersectionObserver' in window)) {
    window.GuyDom.onEntrance(function () { resume(); Array.prototype.forEach.call(els, type); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { type(e.target); io.unobserve(e.target); } });
  }, { threshold: 0.35 });

  // Robustezza: al PRIMO caricamento a freddo (specie con view-transition) l'IO
  // può non scattare e l'elemento resterebbe visibility:hidden. Rivela subito ciò
  // che è già a schermo, ripeti su pageshow (bfcache) e con un fallback di sicurezza.
  function revealVisible() {
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.tw) return;
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < vh && r.bottom > 0) { type(el); io.unobserve(el); }
    });
  }
  // La scrittura cambia testo e layout: non deve ridipingere durante il morph.
  // Al ritorno i titoli gia' completati restano tali (dataset.tw), mentre
  // quelli ancora fuori schermo conservano l'osservazione per il primo reveal.
  window.GuyDom.onEntrance(function () {
    resume();
    Array.prototype.forEach.call(els, function (el) { if (!el.dataset.tw) io.observe(el); });
    revealVisible();
  });
})();
